import axios from "axios";

// Create a new story
export const createStory = async (storyData, token) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/createStory`,
      storyData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Error creating story" };
  }
};

// Get all stories from friends/following
export const getStories = async (token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getStories`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Error fetching stories" };
  }
};

// Get current user's stories
export const getMyStories = async (token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getMyStories`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Error fetching stories" };
  }
};

// Get a specific story by ID
export const getStory = async (storyId, token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getStory/${storyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Error fetching story" };
  }
};

// Get stories by username
export const getUserStories = async (username, token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getUserStories/${username}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Error fetching stories" };
  }
};

// Mark story as viewed
export const viewStory = async (storyId, token) => {
  try {
    await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/viewStory/${storyId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    return error.response?.data?.message || "Error viewing story";
  }
};

// React to a story
export const reactToStory = async (storyId, reaction, token) => {
  try {
    await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/reactToStory/${storyId}`,
      { reaction },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    return error.response?.data?.message || "Error reacting to story";
  }
};

// Remove reaction from story
export const removeReaction = async (storyId, token) => {
  try {
    await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/removeReaction/${storyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    return error.response?.data?.message || "Error removing reaction";
  }
};

// Reply to a story
export const replyToStory = async (storyId, message, token) => {
  try {
    await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/replyToStory/${storyId}`,
      { message },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    return error.response?.data?.message || "Error replying to story";
  }
};

// Delete a story
export const deleteStory = async (storyId, token) => {
  try {
    await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/deleteStory/${storyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    return error.response?.data?.message || "Error deleting story";
  }
};

// Get story viewers
export const getStoryViewers = async (storyId, token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getStoryViewers/${storyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Error fetching viewers" };
  }
};

// Highlight a story
export const highlightStory = async (storyId, highlightGroup, token) => {
  try {
    await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/highlightStory/${storyId}`,
      { highlightGroup },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    return error.response?.data?.message || "Error highlighting story";
  }
};

// Remove from highlights
export const unhighlightStory = async (storyId, token) => {
  try {
    await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/unhighlightStory/${storyId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    return error.response?.data?.message || "Error removing from highlights";
  }
};

// Get highlighted stories
export const getHighlights = async (username, token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getHighlights/${username}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Error fetching highlights" };
  }
};

// Update story privacy
export const updateStoryPrivacy = async (storyId, privacyData, token) => {
  try {
    await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/updateStoryPrivacy/${storyId}`,
      privacyData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    return error.response?.data?.message || "Error updating privacy";
  }
};

// Repost/Share a story
export const repostStory = async (storyId, privacy, token) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/repostStory/${storyId}`,
      { privacy },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", story: data.story };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Error reposting story" };
  }
};

// Get story reactions (owner only)
export const getStoryReactions = async (storyId, token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getStoryReactions/${storyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Error fetching reactions" };
  }
};

// Get story replies (owner only)
export const getStoryReplies = async (storyId, token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getStoryReplies/${storyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Error fetching replies" };
  }
};
